import { CGSpin } from "state-machine/states/cg-spin";
import Components from "slotworks/components/components";
import { getTotalPicks, getCurrentPick } from "utils/calculate-picks-remaining";

export class CGMCBonusSpin extends CGSpin {
    public onExit() {

        Components.betBar.setTotalFreespins(getTotalPicks());

        super.onExit();
    }
}
